import dayjs from 'dayjs';
import { DateTime } from 'luxon';

export const calculateActualClockTimes = (
    scheduledStart: DateTime,
    clockInTime: dayjs.Dayjs,
    clockOutTime: dayjs.Dayjs,
    timezone: string
): { actualClockIn: DateTime; actualClockOut: DateTime } => {
    const shiftDate = scheduledStart.setZone(timezone).startOf('day');

    let actualClockIn = shiftDate.set({
        hour: clockInTime.hour(),
        minute: clockInTime.minute(),
    });
    if (actualClockIn < scheduledStart) {
        actualClockIn = actualClockIn.plus({ days: 1 });
    }

    let actualClockOut = shiftDate.set({
        hour: clockOutTime.hour(),
        minute: clockOutTime.minute(),
    });
    if (actualClockOut < actualClockIn) {
        actualClockOut = actualClockOut.plus({ days: 1 });
    }

    return { actualClockIn, actualClockOut };
};
